import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import FeaturedArticle from './components/FeaturedArticle';
import FAQSection from './components/FAQSection';
import { articles } from '@/mocks/articles';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <FeaturedArticle />

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-[1440px] mx-auto px-4 md:px-6">
            <div className="text-center mb-12 md:mb-16">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
                SEO Guides
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
                Vigorbuy Spreadsheet Articles &amp; Guides
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
                In-depth articles covering everything from beginner tutorials to advanced shopping strategies, safety tips, and category breakdowns — all written to help you shop smarter with Vigorbuy Spreadsheet.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7 max-w-6xl mx-auto">
              {articles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer block no-underline"
                >
                  <div className="aspect-[16/10] w-full overflow-hidden">
                    <img
                      src={article.heroImage}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5 md:p-6">
                    <div className="flex items-center gap-2 mb-3">
                      <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-400">{article.readTime}</span>
                    </div>
                    <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                      {article.metaDescription}
                    </p>
                    <div className="flex items-center gap-1.5 mt-4 text-sm font-medium text-primary-600">
                      Read Article
                      <i className="ri-arrow-right-line text-xs"></i>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            <div className="text-center mt-10">
              <Link
                to="/shopping-guide"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                View All Guides
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        <FAQSection />

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-[1440px] mx-auto px-4 md:px-6">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20gradient%20composition%20with%20soft%20coral%20and%20cream%20tones%20blending%20smoothly%2C%20gentle%20flowing%20organic%20wave%20shapes%2C%20modern%20editorial%20style%2C%20airy%20atmospheric%20background%20with%20subtle%20texture%20overlay%2C%20elegant%20and%20inviting%20aesthetic%20suitable%20for%20call%20to%20action%20banner%2C%20luminous%20warm%20glow%20effect%2C%20sophisticated%20soft%20contrast&width=1400&height=400&seq=vigorbuy-cta-2026&orientation=landscape"
                alt=""
                className="w-full h-[300px] md:h-[360px] object-cover rounded-2xl"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/35 to-black/20 rounded-2xl"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
                <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3">
                  Ready To Explore Vigorbuy Spreadsheet?
                </h2>
                <p className="text-sm md:text-base text-background-50/80 max-w-lg mb-6">
                  Discover smarter shopping with organized guides, comparisons, and updated resources.
                </p>
                <div className="flex flex-col sm:flex-row items-center gap-3">
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-400 transition-all whitespace-nowrap"
                  >
                    Visit Main Website
                    <i className="ri-arrow-right-up-line"></i>
                  </a>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl text-sm font-semibold bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/25 hover:bg-background-50/25 transition-all whitespace-nowrap"
                  >
                    Buy It Now
                    <i className="ri-shopping-cart-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-[1440px] mx-auto px-4 md:px-6">
            <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
              {['Shoes', 'Hoodies', 'T-Shirts', 'Jackets', 'Accessories', 'Bags', 'Jersey', 'Perfumes'].map((tag) => (
                <span
                  key={tag}
                  className="px-4 py-2 rounded-full bg-background-50 text-xs md:text-sm text-foreground-600 border border-background-200/70 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
            <p className="text-center text-xs text-foreground-400 mt-6">
              Trusted by shoppers researching sneakers, streetwear, fashion, and accessories
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}